import React from 'react'
import {FilterLabel} from '../types/Query'
import styles from './QueryVisualizerFilterDetails.module.scss';
import {ReactComponent as FilterDetailsIcon} from '../../../components/query-builder/icons/FilterDetails.svg'

export const QueryVisualizerFilterDetails = ({filterLabels}: { filterLabels: FilterLabel[] | undefined }) => {

    let filterKeyValuesPair

    if (filterLabels && filterLabels.length > 0) {

        filterKeyValuesPair = filterLabels.map((filterLabel, index) => {

            const filterLabelsList = (filterLabel.values || [])
                .map(val => String(val ?? '').trim())
                .filter(Boolean)
                .reduce((previousValue, currentValue, index, array) => {
                    const isLast = index === array.length - 1
                    if (index === 0) return currentValue
                    if (isLast) return `${previousValue} & ${currentValue}`
                    return `${previousValue}, ${currentValue}`
                }, '')

            return (
                <span key={index}><strong>{filterLabel.title}: </strong>{filterLabelsList}. {' '}</span>
            )
        })
    }

    return <div className={styles.filterDetails}>
        <FilterDetailsIcon className = {styles.icon}/>
        <span className={styles.filterDetailsLabel}>Filter Details:</span>
        {filterKeyValuesPair && filterKeyValuesPair.length > 0 ? filterKeyValuesPair : 'None'}
    </div>

}